import type { FC } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { EmptyState } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

export const TopicsEmptyState: FC = () => (
    <Box
        background={colorsPalettes.bluegrey[100]}
        height="170px"
    >
        <EmptyState
            title={translate("llm.setup.modal.topics.emptystate.title")}
            subtitle={translate("llm.setup.modal.topics.emptystate.subtitle")}
        />
    </Box>
);
